// extracted by mini-css-extract-plugin
export default {"container":"ValidationError_container__1ZTpQ","icon":"ValidationError_icon__uTPMU"};